// Helpful? under the platform agent's finished answers and cards (D10). Wording from the Amigo design's copy sheet
// (Helpful?).
export default {
  question: 'Pomocne?',
  helpful: 'Pomocne',
  not_helpful: 'Niepomocne',
  thanks: 'Dziękujemy, odnotowano.',
};
